import qualityEventsHelpers from '../quality-events.helpers';

export const BOUGHT_MATERIALS_QUALITY_EVENTS = {
    toggleInPurchasedBundle(itemId: number, show: boolean) {
        qualityEventsHelpers.track({
            type: 'toggle_in_purchased_bundle',
            item_id: itemId,
            extra: show ? 'show' : 'hide'
        });
    }
};
